import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  margin: 100px 0;
  padding: 0 200px;
  align-items: center;
  column-gap: 100px;
`;

export const Left = styled.img`
  width: 595px;
  height: 700px;
`;
export const Right = styled.div`
  width: 595px;
  height: 400px;
  display: flex;
  flex-direction: column;
`;

export const Title = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 38px;
  color: #0d263b;
  margin-bottom: 40px;
`;

export const Text = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 24px;
  color: #696969;
  margin-bottom: 32px;
`;
